<template>
  <span @click="toggleWarning(order)"
        v-tooltip.top="{
          value: order.is_warning
              ? $t('unmarkAsImportantTooltip')
              : $t('markAsImportantTooltip'),
          disabled: billingDataEditingLocked
        }"
        v-if="order?.staff_comment"
        class="p-link pointer"
        :class="{ 'billing-action-disabled': billingDataEditingLocked }"
        style="padding: 4px">
    <i class="ti-comment-alt" :class="{ 'orange-color': order.is_warning}"/>
  </span>
</template>

<script>
import httpClient from "@/services/http.services";
import showErrorsMixins from "@/mixins/showErrorsMixins";
import billingRestrictionsMixin from '@/mixins/billingRestrictionsMixin'

export default {
  mixins: [showErrorsMixins, billingRestrictionsMixin ],
  name: 'InternalCommentWarningBtn',
  emits: ['change-is-warning'],
  props: {
    order: {
      type: [Object, null],
      default: null
    }
  },
  methods: {
    async toggleWarning(order) {
      if (!order || this.billingActionIsRestricted()) return false

      if (!order.id) {
        order.is_warning = !order.is_warning
        this.$emit('change-is-warning', {id: order.id, newState: order.is_warning })
        return
      }

      order.is_warning = !order.is_warning
      try {
        const { status, data } = await httpClient.post('order/toggle-warning', { id: order.id, state: order.is_warning })
        if (status !== 200 && !data?.success) {
          order.is_warning = !order.is_warning
          this.showUnknownError()
        }
      } catch(err) {
        order.is_warning = !order.is_warning
        this.showError(err)
      } finally {
        this.$emit('change-is-warning', {id: order.id, newState: order.is_warning })
      }
    },
  }
}
</script>
<style scoped>
.billing-action-disabled {
  cursor: not-allowed !important;
  opacity: 0.6;
}
</style>